import { CommonModule } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';

import { GlobalErrorHandler } from './global-error-handler';
import { GlobalErrorHandlingRoutingModule } from './global-error-handling-routing.module';
import { GlobalErrorHandlingComponent } from './global-error-handling.component';

@NgModule({
  imports: [
    CommonModule,
    GlobalErrorHandlingRoutingModule
  ],
  declarations: [GlobalErrorHandlingComponent],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    }
  ]
})
export class GlobalErrorHandlingModule { }
